<script>
  import {useIsDemoServer} from "../../hooks/useIsDemoServer.js";

  const {isDemoServer} = useIsDemoServer()
</script>

{#if $isDemoServer}
  <div class="banner_wrap">
    <a href="https://e.apto-service.com/asprova/inquiry.html" target="_blank">
      <img class="banner" src="/assets/demo/banner_03.png" alt="banner for contact page"/>
    </a>
    <a href="https://knowledge.asprova.com/hc/ja/categories/36956402963865-Asprova-My-Schedule" target="_blank">
      <img class="banner" src="/assets/demo/banner_02.png" alt="banner for knowledge center" />
    </a>
  </div>
{/if}

<style>
  .banner_wrap {
    position: fixed;
    bottom: 50px;
    right: 0;
    z-index: 100;
    padding: 0 3rem;
    display: flex;
    gap: .5rem;
  }

  .banner {
    display: flex;
    flex-direction: column;
    box-shadow: rgba(0, 0, 0, 0.24) 0 3px 6px;
    border-radius: 4px;
    transition: .3s;
    background: radial-gradient(circle farthest-side at 200px 200px,
    #fff 70%,
    #e3f4f3 100%);
    &:hover {
      opacity: .7;
    };
    height: 112px;
    width: auto;
    margin: .5rem .5rem 0 0;
  }

  a {
    text-decoration: none;
  }

</style>